"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  list-style: none;\n  margin: 0;\n\n  /* padding trick for maintaining aspect ratio */\n  height: 0;\n  padding: 100% 0 0 0;\n  width: 100%;\n\n  // Circle outline.\n  border-radius: 100%;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);\n\n  &:before {\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-left: -", "%;\n    margin-top: -", "%;\n    width: ", "%;\n    height: ", "%;\n    border-radius: 100%;\n    box-shadow: inset 0 10px 20px rgba(0, 0, 0, 0.19),\n      inset 0 6px 6px rgba(0, 0, 0, 0.23);\n  }\n\n  & li {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n\n    clip-path: url(#sector);\n  }\n\n  & li button {\n    background-color: transparent;\n    border: none;\n    margin: 0;\n    padding: 0;\n    font-size: inherit;\n  }\n\n  & li a,\n  & li button {\n    display: block;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n  }\n\n  ", "\n\n  & li > a > span, \n  & li > button > span {\n    position: absolute;\n    /* exact values here depend on what you are placing inside the items (icon, image, text, etc.) */\n    left: ", "%;\n    top: ", "%;\n\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Calculate the rotation for slice `index` of `itemCount`.
 *
 * Ensures that `itemCount` rotations make up a full circle. The rotation is
 * adjusted so slice 0 is centered at the top of the circle.
 */
var sliceRotation = function sliceRotation(_ref) {
  var itemCount = _ref.itemCount,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index;
  return (index + 0.5) * 360 / itemCount - 90;
};
/**
 * Generates the CSS for rotating `itemCount` number of slices.
 *
 * @param {int} itemCount
 *   The number of items in the menu.
 * @param {string} itemOrientation
 *   Either "toBottom" or "toCenter" to indicate the orientation of the menu
 *   items.
 * @return {string[]}
 *   the created CSS.
 */


var rotateSlices = function rotateSlices(_ref2) {
  var itemCount = _ref2.itemCount,
      itemOrientation = _ref2.itemOrientation;
  return Array(itemCount).fill("").map(function (v, index) {
    return "\n      & li:nth-child(".concat(index + 1, ") {\n        transform: rotate(").concat(sliceRotation({
      itemCount: itemCount,
      index: index
    }), "deg);\n        \n        ").concat(itemOrientation === "toBottom" ? "span {\n              transform: translate(-50%, -50%) rotate(".concat(-sliceRotation({
      itemCount: itemCount,
      index: index
    }), "deg);\n            }") : null, "\n      }\n    ");
  });
};
/**
 * Calculates the horizontal position of text in the slice of a circle.
 *
 * Uses the itemCount to determine the size of an individual slice of the
 * circle. The position of the text will be adjusted to account for a cutout.
 *
 * @param itemCount
 *   The number of items in the menu.
 * @param cutout
 *   An optional value between 0 and 1 that opens up the center of the menu.
 */


var sliceTextPositionX = function sliceTextPositionX(_ref3) {
  var itemCount = _ref3.itemCount,
      _ref3$cutout = _ref3.cutout,
      cutout = _ref3$cutout === void 0 ? 0 : _ref3$cutout;
  // Find the position halfway the slice on the unit circle.
  // Then move it halfway the cutout and the outer circle edge.
  // Finally translate from [-1;1] to [0;100].
  return 50 + Math.cos(Math.PI / itemCount) * (1 + cutout) * 0.5 * 50;
};
/**
 * Calculates the vertical position of text in the slice of a circle.
 *
 * Uses the itemCount to determine the size of an individual slice of the
 * circle. The position of the text will be adjusted to account for a cutout.
 *
 * @param itemCount
 *   The number of items in the menu.
 * @param cutout
 *   An optional value between 0 and 1 that opens up the center of the menu.
 */


var sliceTextPositionY = function sliceTextPositionY(_ref4) {
  var itemCount = _ref4.itemCount,
      _ref4$cutout = _ref4.cutout,
      cutout = _ref4$cutout === void 0 ? 0 : _ref4$cutout;
  // Find the position halfway the slice on the unit circle.
  // Then move it halfway the cutout and the outer circle edge.
  // Finally transform from [1;-1] to [0;100].
  return 50 + Math.sin(Math.PI / itemCount) * (1 + cutout) * 0.5 * -1 * 50;
};

var Menu = _styledComponents.default.ul(_templateObject(), function (_ref5) {
  var cutout = _ref5.cutout;
  return cutout * 100 / 2;
}, function (_ref6) {
  var cutout = _ref6.cutout;
  return cutout * 100 / 2;
}, function (_ref7) {
  var cutout = _ref7.cutout;
  return cutout * 100;
}, function (_ref8) {
  var cutout = _ref8.cutout;
  return cutout * 100;
}, rotateSlices, sliceTextPositionX, sliceTextPositionY, function (props) {
  return props.itemOrientation === "toCenter" ? "// First move by half text width/height so that left/top position is \n         // according to element center. Then rotate to counteract slice rotation.\n         transform: translate(-50%, -50%) rotate(".concat(-sliceRotation(props), "deg);") : null;
});

var isUnitFraction = function isUnitFraction(props, propName, componentName) {
  if (typeof props[propName] !== "number" || props[propName] < 0 || props[propName] > 1) {
    return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`." + "Must be a (decimal) number in range of 0...1 (inclusive).");
  }
};

Menu.propTypes = {
  itemCount: _propTypes.default.number.isRequired,
  cutout: isUnitFraction,
  itemOrientation: _propTypes.default.oneOf(["toBottom", "toCenter"]).isRequired
};
Menu.defaultProps = {
  itemOrientation: "toBottom"
};
var _default = Menu;
exports.default = _default;